<div class="flex flex-row">
  <app-toolbar [items]="breadcrumbItems" class="w-100-percent"></app-toolbar>
</div>

<div class="top-panel p-16">
  <div class="flex flex-row items-center justify-between">
    <h2 class="fw-600 mr-6">Audit Dashboard</h2>
    <div class="flex flex-row items-center">
      <app-search-filter  (keyup)="searchInstance($event, false)" (keyup.enter)="searchInstance($event, true)" [placeholder]="'AUDIT_LIST.SEARCH'"></app-search-filter>
      <!-- Vertical Divider -->
      <div class="vertical-dash ml-12 mr-12"></div>
      <!-- Filters Button -->
      <button [ngClass]="{'filter-disabled': !dataLoaded}" class="flex justify-center items-center context-menu-icon height menu-btn pl-6 pr-6" (click)="filterColumns()">
        <mat-icon svgIcon="filter_alt" class="mr-4"></mat-icon>
        <span class="fw-500 filters">{{'INSTANCE_LIST.FILTERS' | transloco}}</span>
      </button>
    </div>
  </div>
  <div *ngIf="dataLoaded && !showSpinner && !isFailed" class="flex flex-row flex-wrap justify-start items-center pt-10 pl-24 pr-24 pb-16">
  <ng-container *ngIf="initiatedBy?.length">
    <div class="flex flex-row items-center">
      <span class="fw-400">{{ 'TOOLBAR.INITIATED_BY' | transloco }} </span>
        <span [ngClass]="'value-text'" (click)="filterColumns('initiatedBy')"
          class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
      {{ initiatedBy.length }} {{ 'CREATE_SERVICE.SELECTED' | transloco }}
        <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu('initiatedBy')"></mat-icon>
      </span>
    </div>
  </ng-container>
  <ng-container *ngIf="action?.length">
    <div class="flex flex-row items-center mr-16">
      <span class="fw-400">{{ 'TOOLBAR.ACTION' | transloco }}</span>
      <span [ngClass]="'value-text'" (click)="filterColumns('action')" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
        {{action.length }} {{ 'CREATE_SERVICE.SELECTED' | transloco }}
        <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu('action')"></mat-icon>
      </span>
    </div>
  </ng-container>
  <ng-container *ngIf="tenantId?.length">
    <div class="flex flex-row items-center mr-16">
      <span class="fw-400">{{ 'TOOLBAR.TENANT' | transloco }}</span>
      <span [ngClass]="'value-text'" (click)="filterColumns('tenantId')" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
        {{tenantId.length}} {{ 'CREATE_SERVICE.SELECTED' | transloco }}
        <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu('tenantId')"></mat-icon>
      </span>
    </div>
  </ng-container>
  <ng-container *ngIf="status?.length">
    <div class="flex flex-row items-center mr-16">
      <span class="fw-400">{{ 'TOOLBAR.STATUS' | transloco }}</span>
      <span [ngClass]="'value-text'" (click)="filterColumns('status')" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
        {{status.length}} {{ 'CREATE_SERVICE.SELECTED' | transloco }}
        <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu('status')"></mat-icon>
      </span>
    </div>
  </ng-container>
  <div class="flex flex-row items-center mr-16">
    <span *ngIf="initiatedBy?.length || action?.length || tenantId?.length || status?.length" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg"
      (click)="resetFilter()">
      {{ 'BUTTONS.CLEAR_ALL' | transloco }}
    </span>
  </div>
</div>

  <div class="flex flex-col border-radius">
    <table *ngIf="displayedColumns.length" mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" class="mat-elevation">
      <!-- Tenant -->
      <ng-container matColumnDef="tenantId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700">{{ 'AUDIT_LIST.TENANT_NAME' | transloco }}</th>
        <td mat-cell *matCellDef="let data" class="flex flex-row pt-10 img-column">
          <img class="icon-lg mr-8" src="assets/images/bank.png" alt="bank">
          <span class="tenant-id pt-2">{{ data.tenantId }}</span>
        </td>
      </ng-container>

      <!-- Action -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700">{{ 'AUDIT_LIST.ACTION' | transloco }}</th>
        <td mat-cell *matCellDef="let data">{{ data.action }}</td>
      </ng-container>

      <!-- Timestamp -->
      <ng-container matColumnDef="timestamp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700">{{ 'AUDIT_LIST.TIME_STAMP' | transloco }}</th>
        <td mat-cell *matCellDef="let data">
          {{ data.timestamp ? (data.timestamp | date:'dd MMM yyyy HH:mm:ss') : '-' }}
        </td>
      </ng-container>

      <!-- Initiated By -->
      <ng-container matColumnDef="userEmail">
        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 text-center">{{ 'AUDIT_LIST.INITIATED_BY' | transloco }}</th>
        <td mat-cell *matCellDef="let data" class="text-center">
          <img src="assets/images/account_circle.svg" alt="Profile" matTooltip="{{ data.userEmail }}"
            [matTooltipPosition]="'left'" />
        </td>
      </ng-container>

      <!-- Status -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700">
          {{ 'INSTANCE_LIST.STATUS' | transloco }}
        </th>
        <td mat-cell *matCellDef="let data">
          <div class="flex inline-flex justify-center items-center status fw-500" [ngClass]="data.status">
            <mat-icon *ngIf="data.status !== '-'" [svgIcon]="data.status === 'Success' ? 'check_circle' : 'cancel'"
              class="icon-md p-1 mr-2" [ngClass]="data.status">
            </mat-icon>
            <span [ngClass]="data.status">{{ data.status }}</span>
          </div>
        </td>
      </ng-container>

      <!-- Details -->
      <ng-container matColumnDef="details">
         <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700">
          <button mat-icon-button class="settings-btn" (click)="openAuditColumnSettings()">
            <mat-icon svgIcon="settings"></mat-icon>
          </button>
        </th>
        <td mat-cell *matCellDef="let data">
          <span class="view-details" (click)="viewAuditDetails(data)">{{ 'TENANT_LIST.VIEW_DETAILS' | transloco }}</span>
        </td>
      </ng-container>
      
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <!-- Spinner -->
    <mat-card *ngIf="showSpinner" class="flex spinner-container spinner">
      <mat-spinner diameter="24" color="primary" mode="indeterminate"></mat-spinner>
    </mat-card>

    <!-- No Data -->
    <div *ngIf="dataLoaded && filteredData?.length === 0 && !showSpinner && !isFailed"
      class="flex flex-col items-center justify-center pt-48 pb-48">
      <img src="/assets/images/instance-not-found-small.png" alt="No Data Found" class="mb-4" />
      <div class="fw-600 fs-16">
        {{ 'AUDIT_LIST.NO_DATA' | transloco }}
      </div>
    </div>

    <!-- Pagination -->
    <app-paginator *ngIf="dataSource?.data?.length > 0 && showPagination && !isFailed" class="p-24" [length]="total"
      [pageSizeOptions]="[10, 20]" [pageSize]="paginationSize" [pageIndex]="pageIndex" [rangeSize]="3"
      (page)="pageChanged($event)">
    </app-paginator>
</div>